import createSagaMiddleware from "redux-saga";
import { combineReducers, createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { cardTypesReducer } from "./reducers/cardTypeReducer";
import { cardReducer } from "./reducers/cardReducer";
import { modalReducer } from "./reducers/modalReducer";
import { personReducer } from "./reducers/personReducer";
import { currentUserReducer } from "./reducers/loginReducer";
import { administrationSagas, watcherSaga } from "./sagas/rootSaga";
import { fileImportReducer } from "./reducers/fileImportReducer";
import { transactionReducer } from "./reducers/transactionReducer";
import { componentReducer } from "./reducers/componentReducer";
import { trustReducer } from "./reducers/trustManagerReducer";
import { keyStoreReducer } from "./reducers/keyStoreReducer";
import { authorizationReducer } from "./reducers/authorizationReducer";
import { logReducer } from "./reducers/logReducer";
import { actionTypesReducer } from "./reducers/actionTypeReducer";
import { administrationReducer } from "./reducers/administrationReducer";
import { contractReducer } from "./reducers/contractReducer";

import { statisticsReducer } from "./reducers/statisticsReducer";
import { systemStatusMessageReducer } from "./reducers/systemStatusMessageReducer";
import { messageReducer } from "./reducers/messageReducer";
import { hsaReducer } from "./reducers/hsaReducer";
import { loadingReducer } from "./reducers/loadingReducer";
import { infoReducer } from "./reducers/infoReducer";

const reducer = combineReducers({
  cardTypes: cardTypesReducer,
  fileImportState: fileImportReducer,
  authorizationState: authorizationReducer,
  trustState: trustReducer,
  keyGroupState: keyStoreReducer,
  card: cardReducer,
  modal: modalReducer,
  person: personReducer,
  session: currentUserReducer,
  transaction: transactionReducer,
  settings: componentReducer,
  logs: logReducer,
  actionTypes: actionTypesReducer,
  carePrincipal: administrationReducer,
  contract: contractReducer,
  statistics: statisticsReducer,
  systemStatus: systemStatusMessageReducer,
  messages: messageReducer,
  hsaUnits: hsaReducer,
  loadingState: loadingReducer,
  info: infoReducer,
});

const sagaMiddleware = createSagaMiddleware();

const middleware = [sagaMiddleware];

const store = createStore(
  reducer,
  {},
  composeWithDevTools(applyMiddleware(...middleware))
);

sagaMiddleware.run(watcherSaga);
sagaMiddleware.run(administrationSagas);

export default store;
